// libs/gitgraph/src/orientation.ts
var e = /* @__PURE__ */ function(e) {
	return e.VerticalReverse = "vertical-reverse", e.Horizontal = "horizontal", e.HorizontalReverse = "horizontal-reverse", e;
}({});
// libs/gitgraph/src/utils.ts
function t(e, t) {
	return typeof e == "boolean" ? e : t;
}
function n(e, t) {
	return typeof e == "number" ? e : t;
}
function r(e, t) {
	return { ...t.reduce((t, n) => ({
		...t,
		[n]: e[n]
	}), {}) };
}
function i(e, t) {
	console.log(JSON.stringify(e.map((e) => r(e, t)), null, 2));
}
function a(e) {
	return e === void 0;
}
function o(e = {}) {
	return Object.keys(e).reduce((t, n) => a(e[n]) ? t : {
		...t,
		[n]: e[n]
	}, {});
}
function s(e, t, n) {
	let r = n.style.dot.size, i = e.template.arrow.size, a = r + e.template.arrow.offset, o = Math.PI / 7, s = c(e, t, n), l = a * Math.cos(s), u = a * Math.sin(s), d = (a + i) * Math.cos(s - o), f = (a + i) * Math.sin(s - o), p = (a + i / 2) * Math.cos(s), m = (a + i / 2) * Math.sin(s), h = (a + i) * Math.cos(s + o), g = (a + i) * Math.sin(s + o);
	return `M${l},${u} L${d},${f} Q${p},${m} ${h},${g} L${h},${g}`;
}
function c(t, n, r) {
	let i = n.x - r.x, a = n.y - r.y, o = t.template.commit.spacing, s, c;
	switch (t.orientation) {
		case e.Horizontal:
			s = a, c = -o;
			break;
		case e.HorizontalReverse:
			s = a, c = o;
			break;
		case e.VerticalReverse:
			s = -o, c = i;
			break;
		default: s = o, c = i;
	}
	return t.isVertical ? Math.abs(a) > o && (c = 0) : Math.abs(i) > o && (s = 0), t.reverseArrow && (s *= -1, c *= -1), Math.atan2(s, c);
}
// libs/gitgraph/src/template.ts
var l = /* @__PURE__ */ function(e) {
	return e.Bezier = "bezier", e.Straight = "straight", e;
}({}), u = "normal 12pt Calibri", d = class {
	colors;
	arrow;
	branch;
	commit;
	tag;
	constructor(e) {
		e.branch = e.branch || {}, e.branch.label = e.branch.label || {}, e.arrow = e.arrow || {}, e.commit = e.commit || {}, e.commit.dot = e.commit.dot || {}, e.commit.message = e.commit.message || {}, this.colors = e.colors || ["#000000"], this.branch = {
			color: e.branch.color,
			lineWidth: e.branch.lineWidth || 2,
			mergeStyle: e.branch.mergeStyle || "bezier",
			spacing: n(e.branch.spacing, 20),
			label: {
				display: t(e.branch.label.display, !0),
				color: e.branch.label.color || e.commit.color,
				strokeColor: e.branch.label.strokeColor || e.commit.color,
				bgColor: e.branch.label.bgColor || "white",
				font: e.branch.label.font || e.commit.message.font || "normal 12pt Calibri",
				borderRadius: n(e.branch.label.borderRadius, 10)
			}
		}, this.arrow = {
			size: e.arrow.size || null,
			color: e.arrow.color || null,
			offset: e.arrow.offset || 2
		}, this.commit = {
			color: e.commit.color,
			spacing: n(e.commit.spacing, 25),
			hasTooltipInCompactMode: t(e.commit.hasTooltipInCompactMode, !0),
			dot: {
				color: e.commit.dot.color || e.commit.color,
				size: e.commit.dot.size || 3,
				strokeWidth: n(e.commit.dot.strokeWidth, 0),
				strokeColor: e.commit.dot.strokeColor,
				font: e.commit.dot.font || e.commit.message.font || "normal 10pt Calibri"
			},
			message: {
				display: t(e.commit.message.display, !0),
				displayAuthor: t(e.commit.message.displayAuthor, !0),
				displayHash: t(e.commit.message.displayHash, !0),
				color: e.commit.message.color || e.commit.color,
				font: e.commit.message.font || "normal 12pt Calibri"
			}
		}, this.tag = e.tag || {};
	}
}, f = new d({
	colors: [
		"#6963FF",
		"#47E8D4",
		"#6BDB52",
		"#E84BA5",
		"#FFA657"
	],
	branch: {
		color: "#000000",
		lineWidth: 4,
		spacing: 50,
		mergeStyle: "straight"
	},
	commit: {
		spacing: 60,
		dot: {
			size: 16,
			strokeColor: "#000000",
			strokeWidth: 4
		},
		message: { color: "black" }
	},
	arrow: {
		size: 16,
		offset: -1.5
	}
}), p = new d({
	colors: [
		"#979797",
		"#008fb5",
		"#f1c109"
	],
	branch: {
		lineWidth: 10,
		spacing: 50
	},
	commit: {
		spacing: 80,
		dot: { size: 14 },
		message: { font: "normal 14pt Arial" }
	}
}), m = /* @__PURE__ */ function(e) {
	return e.Metro = "metro", e.BlackArrow = "blackarrow", e;
}({});
function h(e, t) {
	let n = g(e);
	return t.branch ||= {}, t.commit ||= {}, {
		colors: t.colors || n.colors,
		arrow: {
			...n.arrow,
			...t.arrow
		},
		branch: {
			...n.branch,
			...t.branch,
			label: {
				...n.branch.label,
				...t.branch.label
			}
		},
		commit: {
			...n.commit,
			...t.commit,
			dot: {
				...n.commit.dot,
				...t.commit.dot
			},
			message: {
				...n.commit.message,
				...t.commit.message
			}
		},
		tag: {
			...n.tag,
			...t.tag
		}
	};
}
function g(e) {
	return e ? typeof e == "string" ? {
		blackarrow: f,
		metro: p
	}[e] : e : p;
}
// libs/gitgraph/src/tag.ts
var _ = class {
	name;
	render;
	get style() {
		return {
			strokeColor: this.tagStyle.strokeColor || this.commitStyle.color,
			bgColor: this.tagStyle.bgColor || this.commitStyle.color,
			color: this.tagStyle.color || "white",
			font: this.tagStyle.font || this.commitStyle.message.font || "normal 12pt Calibri",
			borderRadius: n(this.tagStyle.borderRadius, 10),
			pointerWidth: n(this.tagStyle.pointerWidth, 12)
		};
	}
	tagStyle;
	commitStyle;
	constructor(e, t, n, r) {
		this.name = e, this.tagStyle = t, this.commitStyle = r, this.render = n;
	}
}, v = () => (Math.random().toString(16).substring(3) + Math.random().toString(16).substring(3) + Math.random().toString(16).substring(3) + Math.random().toString(16).substring(3)).substring(0, 40), y = class e {
	refs = [];
	x = 0;
	y = 0;
	hash;
	hashAbbrev;
	parents;
	parentsAbbrev;
	author;
	committer;
	subject;
	body;
	get message() {
		let e = "";
		return this.style.message.displayHash && (e += `${this.hashAbbrev} `), e += this.subject, this.style.message.displayAuthor && (e += ` - ${this.author.name} <${this.author.email}>`), e;
	}
	style;
	dotText;
	dashedEdge;
	branches;
	get branchToDisplay() {
		return this.branches ? this.branches[0] : "";
	}
	tags;
	onClick;
	onMessageClick;
	onMouseOver;
	onMouseOut;
	renderDot;
	renderMessage;
	renderTooltip;
	constructor(e) {
		let t, n;
		try {
			[, t, n] = e.author.match(/(.*) <(.*)>/);
		} catch {
			[t, n] = [e.author, ""];
		}
		this.author = {
			name: t,
			email: n,
			timestamp: Date.now()
		}, this.committer = {
			name: t,
			email: n,
			timestamp: Date.now()
		}, this.subject = e.subject, this.body = e.body || "", this.hash = e.hash || v(), this.hashAbbrev = this.hash.substring(0, 7), this.parents = e.parents ? e.parents : [], this.parentsAbbrev = this.parents.map((e) => e.substring(0, 7)), this.style = {
			...e.style,
			message: { ...e.style.message },
			dot: { ...e.style.dot }
		}, this.dotText = e.dotText, this.dashedEdge = e.dashedEdge, this.onClick = () => e.onClick ? e.onClick(this) : void 0, this.onMessageClick = () => e.onMessageClick ? e.onMessageClick(this) : void 0, this.onMouseOver = () => e.onMouseOver ? e.onMouseOver(this) : void 0, this.onMouseOut = () => e.onMouseOut ? e.onMouseOut(this) : void 0, this.renderDot = e.renderDot, this.renderMessage = e.renderMessage, this.renderTooltip = e.renderTooltip;
	}
	setRefs(e) {
		return this.refs = e.getNames(this.hash), this;
	}
	setTags(e, t, n) {
		return this.tags = e.getNames(this.hash).map((e) => new _(e, t(e), n(e), this.style)), this;
	}
	setBranches(e) {
		return this.branches = e, this;
	}
	setPosition({ x: e, y: t }) {
		return this.x = e, this.y = t, this;
	}
	withDefaultColor(e) {
		let t = {
			...this.style,
			dot: { ...this.style.dot },
			message: { ...this.style.message }
		};
		t.color ||= e, t.dot.color || (t.dot.color = e), t.message.color || (t.message.color = e);
		let n = this.cloneCommit();
		return n.style = t, n;
	}
	cloneCommit() {
		let t = new e({
			author: `${this.author.name} <${this.author.email}>`,
			subject: this.subject,
			style: this.style,
			body: this.body,
			hash: this.hash,
			parents: this.parents,
			dotText: this.dotText,
			dashedEdge: this.dashedEdge,
			onClick: this.onClick,
			onMessageClick: this.onMessageClick,
			onMouseOver: this.onMouseOver,
			onMouseOut: this.onMouseOut,
			renderDot: this.renderDot,
			renderMessage: this.renderMessage,
			renderTooltip: this.renderTooltip
		});
		return t.refs = this.refs, t.branches = this.branches, t.tags = this.tags, t.x = this.x, t.y = this.y, t;
	}
}, b = class {
	name;
	_branch;
	_graph;
	_onGraphUpdate;
	constructor(e, t, n) {
		this._branch = e, this.name = e.name, this._graph = t, this._onGraphUpdate = n;
	}
	branch(e) {
		if (this._branch.isDeleted() && !this._isReferenced()) throw Error(`Cannot branch from the deleted branch "${this.name}"`);
		let t = typeof e == "string" ? { name: e } : e;
		return t.from = this, this._graph.createBranch(t).getUserApi();
	}
	commit(e) {
		if (this._branch.isDeleted() && !this._isReferenced()) throw Error(`Cannot commit on the deleted branch "${this.name}"`);
		return typeof e == "string" && (e = { subject: e }), e ||= {}, this._commitWithParents(e, []), this._onGraphUpdate(), this;
	}
	delete() {
		if (this._graph.refs.getCommit("HEAD") === this._graph.refs.getCommit(this.name)) throw Error(`Cannot delete the checked out branch "${this.name}"`);
		return [...(function* (e, t) {
			let n = (e, t) => e.commits.find(({ hash: e }) => e === t), r = n(e, e.refs.getCommit(t.name));
			for (; r && r.hash !== t.parentCommitHash;) yield r, r = n(e, r.parents[0]);
		})(this._graph, this._branch)].forEach((e) => {
			e.refs = e.refs.filter((e) => e !== this.name);
		}), this._graph.refs.delete(this.name), this._graph.branches.delete(this.name), this._branch = w(this._graph, this._branch.style, () => {}), this._onGraphUpdate(), this;
	}
	merge(...e) {
		if (this._branch.isDeleted() && !this._isReferenced()) throw Error(`Cannot merge to the deleted branch "${this.name}"`);
		let t = e[0];
		x(t) || (t = {
			branch: e[0],
			fastForward: !1,
			commitOptions: { subject: e[1] }
		});
		let { branch: n, fastForward: r, commitOptions: i } = t, a = typeof n == "string" ? n : n?.name, o = this._graph.refs.getCommit(a);
		if (!o) throw Error(`The branch called "${a}" is unknown`);
		let s = !1;
		if (r) {
			let e = this._graph.refs.getCommit(this._branch.name);
			e && (s = this._areCommitsConnected(e, o));
		}
		return r && s ? this._fastForwardTo(o) : this._commitWithParents({
			...i,
			subject: i && i.subject || `Merge branch ${a}`
		}, [o]), this._onGraphUpdate(), this;
	}
	tag(e) {
		if (this._branch.isDeleted() && !this._isReferenced()) throw Error(`Cannot tag on the deleted branch "${this.name}"`);
		return typeof e == "string" ? this._graph.getUserApi().tag({
			name: e,
			ref: this._branch.name
		}) : this._graph.getUserApi().tag({
			...e,
			ref: this._branch.name
		}), this;
	}
	checkout() {
		if (this._branch.isDeleted() && !this._isReferenced()) throw Error(`Cannot checkout the deleted branch "${this.name}"`);
		let e = this._branch, t = this._graph.refs.getCommit(e.name);
		return this._graph.currentBranch = e, t && this._graph.refs.set("HEAD", t), this;
	}
	_commitWithParents(e, t) {
		let n = this._graph.refs.getCommit(this._branch.name);
		n ? t.unshift(n) : this._branch.parentCommitHash && t.unshift(this._branch.parentCommitHash);
		let { tag: r, ...i } = e, a = new y({
			hash: this._graph.generateCommitHash(),
			author: this._branch.commitDefaultOptions.author || this._graph.author,
			subject: this._branch.commitDefaultOptions.subject || this._graph.commitMessage,
			...i,
			parents: t,
			style: this._getCommitStyle(e.style)
		});
		n ? this._graph.refs.getNames(n).forEach((e) => this._graph.refs.set(e, a.hash)) : this._graph.refs.set(this._branch.name, a.hash), this._graph.commits.push(a), this.checkout(), r && this.tag(r);
	}
	_areCommitsConnected(e, t) {
		let n = this._graph.commits.find(({ hash: e }) => t === e);
		return !n || n.parents.length === 0 ? !1 : n.parents.includes(e) ? !0 : n.parents.some((t) => this._areCommitsConnected(e, t));
	}
	_fastForwardTo(e) {
		this._graph.refs.set(this._branch.name, e);
	}
	_getCommitStyle(e = {}) {
		return {
			...o(this._graph.template.commit),
			...o(this._branch.commitDefaultOptions.style),
			...e,
			message: {
				...o(this._graph.template.commit.message),
				...o(this._branch.commitDefaultOptions.style.message),
				...e.message,
				...o({ display: this._graph.shouldDisplayCommitMessage && void 0 })
			},
			dot: {
				...o(this._graph.template.commit.dot),
				...o(this._branch.commitDefaultOptions.style.dot),
				...e.dot
			}
		};
	}
	_isReferenced() {
		return this._graph.branches.has(this.name) || this._graph.refs.hasName(this.name) || this._graph.commits.reduce((e, { refs: t }) => [...e, ...t], []).includes(this.name);
	}
};
function x(e) {
	return typeof e == "object" && !(e instanceof b);
}
// libs/gitgraph/src/branch.ts
var S = "", C = class {
	name;
	style;
	computedColor;
	parentCommitHash;
	commitDefaultOptions;
	renderLabel;
	gitgraph;
	onGraphUpdate;
	constructor(e) {
		this.gitgraph = e.gitgraph, this.name = e.name, this.style = e.style, this.parentCommitHash = e.parentCommitHash, this.commitDefaultOptions = e.commitDefaultOptions || { style: {} }, this.onGraphUpdate = e.onGraphUpdate, this.renderLabel = e.renderLabel;
	}
	getUserApi() {
		return new b(this, this.gitgraph, this.onGraphUpdate);
	}
	isDeleted() {
		return this.name === "";
	}
};
function w(e, t, n) {
	return new C({
		name: "",
		gitgraph: e,
		style: t,
		onGraphUpdate: n
	});
}
// libs/gitgraph/src/branches-paths.ts
var T = class {
	commits;
	branches;
	commitSpacing;
	isGraphVertical;
	isGraphReverse;
	createDeletedBranch;
	branchesPaths = /* @__PURE__ */ new Map();
	constructor(e, t, n, r, i, a) {
		this.commits = e, this.branches = t, this.commitSpacing = n, this.isGraphVertical = r, this.isGraphReverse = i, this.createDeletedBranch = a;
	}
	execute() {
		return this.fromCommits(), this.withMergeCommits(), this.smoothBranchesPaths();
	}
	fromCommits() {
		this.commits.forEach((e) => {
			let t = this.branches.get(e.branchToDisplay);
			t ||= this.getDeletedBranchInPath() || this.createDeletedBranch();
			let n = [], r = this.branchesPaths.get(t), i = this.commits.find(({ hash: t }) => t === e.parents[0]);
			r ? n.push(...r) : i && n.push({
				x: i.x,
				y: i.y
			}), n.push({
				x: e.x,
				y: e.y
			}), this.branchesPaths.set(t, n);
		});
	}
	withMergeCommits() {
		this.commits.filter(({ parents: e }) => e.length > 1).forEach((e) => {
			let t = this.commits.find(({ hash: t }) => t === e.parents[1]);
			if (!t) return;
			let n = t.branches ? t.branches[0] : "", i = this.branches.get(n);
			if (!i && (i = this.getDeletedBranchInPath(), !i)) return;
			let a = [...this.branchesPaths.get(i) || []], o = [...a].reverse().find((e) => !e.mergeCommit);
			this.branchesPaths.set(i, [...a, {
				x: e.x,
				y: e.y,
				mergeCommit: !0,
				dashed: e.dashedEdge,
				dashedFrom: e.dashedEdge && o ? r(o, ["x", "y"]) : void 0
			}]);
		});
	}
	getDeletedBranchInPath() {
		return Array.from(this.branchesPaths.keys()).find((e) => e.isDeleted());
	}
	smoothBranchesPaths() {
		let e = /* @__PURE__ */ new Map();
		return this.branchesPaths.forEach((t, n) => {
			if (t.length <= 1) {
				e.set(n, [t]);
				return;
			}
			t = this.isGraphVertical ? t.sort((e, t) => e.y > t.y ? -1 : 1) : t.sort((e, t) => e.x > t.x ? 1 : -1), this.isGraphReverse && (t = t.reverse());
			let i = t.reduce((e, n, i) => {
				if (n.mergeCommit) {
					e[e.length - 1].push(r(n, [
						"x",
						"y",
						"dashed",
						"dashedFrom"
					]));
					let a = i - 1, o = t[a];
					for (; a >= 0 && o.mergeCommit;) a--, o = t[a];
					a >= 0 && e.push([o]);
				} else e[e.length - 1].push(n);
				return e;
			}, [[]]);
			this.isGraphReverse && i.forEach((e) => e.reverse()), this.isGraphVertical ? i.forEach((t) => {
				if (t.length <= 1) return;
				let r = t[0], i = t[t.length - 1], a = t[1].x, o = Math.round(Math.abs(r.y - i.y) / this.commitSpacing) - 1, s = o > 0 ? Array(o).fill(0).map((e, n) => ({
					x: a,
					y: t[0].y - this.commitSpacing * (n + 1)
				})) : [], c = e.get(n) || [];
				e.set(n, [...c, [
					r,
					...s,
					i
				]]);
			}) : i.forEach((t) => {
				if (t.length <= 1) return;
				let r = t[0], i = t[t.length - 1], a = t[1].y, o = Math.round(Math.abs(r.x - i.x) / this.commitSpacing) - 1, s = o > 0 ? Array(o).fill(0).map((e, n) => ({
					y: a,
					x: t[0].x + this.commitSpacing * (n + 1)
				})) : [], c = e.get(n) || [];
				e.set(n, [...c, [
					r,
					...s,
					i
				]]);
			});
		}), e;
	}
};
function E(e, t, n) {
	return e.map((e) => "M" + e.map(({ x: e, y: r }, i, a) => {
		if (t && a.length > 1 && (i === 1 || i === a.length - 1)) {
			let t = a[i - 1];
			if (n) {
				let n = (t.y + r) / 2;
				return `C ${t.x} ${n} ${e} ${n} ${e} ${r}`;
			}
			{
				let n = (t.x + e) / 2;
				return `C ${n} ${t.y} ${n} ${r} ${e} ${r}`;
			}
		}
		return `L ${e} ${r}`;
	}).join(" ").slice(1)).join(" ");
}
// libs/gitgraph/src/column-manager.ts
var D = class {
	branches = /* @__PURE__ */ new Map();
	columnAssignments = /* @__PURE__ */ new Map();
	colors;
	constructor(e, t, n) {
		this.colors = t, this.analyzeBranchLifecycles(e), this.assignColumns(n);
	}
	get(e) {
		let t = this.columnAssignments.get(e);
		return t === void 0 ? 0 : t;
	}
	getColorOf(e) {
		let t = this.get(e);
		return this.colors[t % this.colors.length];
	}
	analyzeBranchLifecycles(e) {
		e.forEach((t, n) => {
			let r = t.branchToDisplay;
			if (this.branches.has(r)) {
				let e = this.branches.get(r);
				e && (e.lastCommitIndex = n);
			} else {
				let i, a;
				if (n > 0 && t.parents.length > 0 && (a = t.parents[0], a)) {
					let t = e.find((e, t) => t < n && e.hash === a);
					if (t) {
						i = t.branchToDisplay;
						let o = n > 0 ? e[n - 1] : null;
						o && o.hash === a && o.branchToDisplay !== r && (i = o.branchToDisplay);
					}
				}
				let o = {
					name: r,
					firstCommitIndex: n,
					lastCommitIndex: n,
					parentCommitIndex: e.findIndex((e) => e.hash === a),
					parentBranch: i,
					parentCommitHash: a
				};
				this.branches.set(r, o);
			}
			t.parents.length > 1 && e.forEach((e, r) => {
				if (r < n && t.parents.includes(e.hash) && e.branchToDisplay !== t.branchToDisplay) {
					let t = this.branches.get(e.branchToDisplay);
					t && !t.mergedAt && (t.mergedAt = n);
				}
			});
		});
	}
	assignColumns(e) {
		let t = Array.from(this.branches.values()).sort((e, t) => e.firstCommitIndex - t.firstCommitIndex);
		e && (t = t.sort((t, n) => e(t.name, n.name)));
		let n = /* @__PURE__ */ new Map();
		t.forEach((e) => {
			if (e.name === "main" || e.name === "master") {
				n.set(0, [e]), this.columnAssignments.set(e.name, 0), e.column = 0;
				return;
			}
			let t = 0, r = !1;
			for (; !r;) {
				let i = n.get(t) || [];
				if (i.length === 0) n.set(t, [e]), this.columnAssignments.set(e.name, t), e.column = t, r = !0;
				else {
					let a = !0;
					for (let t of i) if (!this.canReuseColumn(t, e)) {
						a = !1;
						break;
					}
					a ? (i.push(e), n.set(t, i), this.columnAssignments.set(e.name, t), e.column = t, r = !0) : t++;
				}
			}
		});
	}
	canReuseColumn(e, t) {
		if (e.name === "master" || e.name === "main" || t.parentBranch === e.name || t.parentCommitHash && e.parentCommitHash && t.parentCommitHash === e.parentCommitHash) return !1;
		let n = t.firstCommitIndex, r = t.mergedAt === void 0 ? t.lastCommitIndex : t.mergedAt, i = e.firstCommitIndex;
		if (n <= (e.mergedAt === void 0 ? e.lastCommitIndex : e.mergedAt) && r >= i) return !1;
		let a = e.mergedAt === void 0 ? 2 ** 53 - 1 : e.mergedAt;
		return t.mergedAt !== void 0 && t.mergedAt, t.parentCommitIndex < e.lastCommitIndex ? !1 : a < t.firstCommitIndex || (t.firstCommitIndex, !1);
	}
}, O = class {
	rows = /* @__PURE__ */ new Map();
	maxRowCache = void 0;
	constructor(e) {
		this.computeRowsFromCommits(e);
	}
	getRowOf(e) {
		return this.rows.get(e) || 0;
	}
	getMaxRow() {
		return this.maxRowCache === void 0 && (this.maxRowCache = k(Array.from(this.rows.values())).length - 1), this.maxRowCache;
	}
	computeRowsFromCommits(e) {
		e.forEach((e, t) => {
			this.rows.set(e.hash, t);
		}), this.maxRowCache = void 0;
	}
};
function k(e) {
	let t = /* @__PURE__ */ new Set();
	return e.forEach((e) => t.add(e)), Array.from(t);
}
// libs/gitgraph/src/graph-rows/compact.ts
var A = class extends O {
	computeRowsFromCommits(e) {
		e.forEach((t, n) => {
			let r = n;
			if (n !== 0) {
				let i = this.getRowOf(t.parents[0]), a = e[n - 1];
				r = Math.max(i + 1, this.getRowOf(a.hash)), t.parents.length > 1 && i < this.getRowOf(t.parents[1]) && r++;
			}
			this.rows.set(t.hash, r);
		});
	}
}, j = /* @__PURE__ */ function(e) {
	return e.Compact = "compact", e;
}(j || {});
// libs/gitgraph/src/graph-rows/index.ts
function M(e, t) {
	return e === j.Compact ? new A(t) : new O(t);
}
// libs/gitgraph/src/refs.ts
var N = class {
	commitPerName = /* @__PURE__ */ new Map();
	namesPerCommit = /* @__PURE__ */ new Map();
	set(e, t) {
		let n = this.commitPerName.get(e);
		return n && this.removeNameFrom(n, e), this.addNameTo(t, e), this.addCommitTo(e, t), this;
	}
	delete(e) {
		return this.hasName(e) && (this.removeNameFrom(this.getCommit(e), e), this.commitPerName.delete(e)), this;
	}
	getCommit(e) {
		return this.commitPerName.get(e);
	}
	getNames(e) {
		return this.namesPerCommit.get(e) || [];
	}
	getAllNames() {
		return Array.from(this.commitPerName.keys());
	}
	hasCommit(e) {
		return this.namesPerCommit.has(e);
	}
	hasName(e) {
		return this.commitPerName.has(e);
	}
	removeNameFrom(e, t) {
		let n = this.namesPerCommit.get(e) || [];
		this.namesPerCommit.set(e, n.filter((e) => e !== t));
	}
	addNameTo(e, t) {
		let n = this.namesPerCommit.get(e) || [];
		this.namesPerCommit.set(e, [...n, t]);
	}
	addCommitTo(e, t) {
		this.commitPerName.set(e, t);
	}
}, P = class {
	_graph;
	_onGraphUpdate;
	constructor(e, t) {
		this._graph = e, this._onGraphUpdate = t;
	}
	clear() {
		return this._graph.refs = new N(), this._graph.tags = new N(), this._graph.commits = [], this._graph.branches = /* @__PURE__ */ new Map(), this._graph.currentBranch = this._graph.createBranch("master"), this._onGraphUpdate(), this;
	}
	commit(e) {
		return this._graph.currentBranch.getUserApi().commit(e), this;
	}
	branch(e) {
		return this._graph.createBranch(e).getUserApi();
	}
	tag(...e) {
		let t, n, r, i;
		if (typeof e[0] == "string" ? (t = e[0], n = e[1]) : (t = e[0].name, n = e[0].ref, r = e[0].style, i = e[0].render), !n) {
			let e = this._graph.refs.getCommit("HEAD");
			if (!e) return this;
			n = e;
		}
		let a;
		if (this._graph.refs.hasCommit(n) && (a = n), this._graph.refs.hasName(n) && (a = this._graph.refs.getCommit(n)), !a) throw Error(`The ref "${n}" does not exist`);
		return this._graph.tags.set(t, a), this._graph.tagStyles[t] = r, this._graph.tagRenders[t] = i, this._onGraphUpdate(), this;
	}
	import(e) {
		let t = /* @__PURE__ */ Error("Only `git2json` format is supported for imported data.");
		if (!Array.isArray(e) || !e.every((e) => typeof e == "object" && typeof e.author == "object" && Array.isArray(e.refs))) throw t;
		let n = e.map((e) => ({
			...e,
			style: {
				...this._graph.template.commit,
				message: {
					...this._graph.template.commit.message,
					display: this._graph.shouldDisplayCommitMessage
				}
			},
			author: `${e.author.name} <${e.author.email}>`
		})).reverse();
		this.clear(), this._graph.commits = n.map((e) => new y(e)), n.forEach(({ refs: e, hash: t }) => {
			if (!e || !t) return;
			let n = "tag: ";
			e.map((e) => e.split(n)).map(([e, t]) => t).filter((e) => typeof e == "string").forEach((e) => this._graph.tags.set(e, t)), e.filter((e) => !e.startsWith(n)).forEach((e) => this._graph.refs.set(e, t));
		});
		let r = this._getBranches();
		return this._graph.commits.map((e) => this._withBranches(r, e)).reduce((e, t) => (t.branches && t.branches.forEach((t) => e.add(t)), e), /* @__PURE__ */ new Set()).forEach((e) => this.branch(e)), this._onGraphUpdate(), this;
	}
	_withBranches(e, t) {
		let n = Array.from((e.get(t.hash) || /* @__PURE__ */ new Set()).values());
		return n.length === 0 && (n = [""]), t.setBranches(n);
	}
	_getBranches() {
		let e = /* @__PURE__ */ new Map(), t = [];
		return this._graph.refs.getAllNames().filter((e) => e !== "HEAD").forEach((n) => {
			let r = this._graph.refs.getCommit(n);
			for (r && t.push(r); t.length > 0;) {
				let r = t.pop(), i = this._graph.commits.find(({ hash: e }) => e === r), a = e.get(r) || /* @__PURE__ */ new Set();
				a.add(n), e.set(r, a), i && i.parents && i.parents.length > 0 && t.push(i.parents[0]);
			}
		}), e;
	}
}, F = class {
	orientation;
	get isHorizontal() {
		return this.orientation === e.Horizontal || this.orientation === e.HorizontalReverse;
	}
	get isVertical() {
		return !this.isHorizontal;
	}
	get isReverse() {
		return this.orientation === e.HorizontalReverse || this.orientation === e.VerticalReverse;
	}
	get shouldDisplayCommitMessage() {
		return !this.isHorizontal && this.mode !== j.Compact;
	}
	reverseArrow;
	initCommitOffsetX;
	initCommitOffsetY;
	mode;
	author;
	commitMessage;
	generateCommitHash;
	branchesOrderFunction;
	template;
	branchLabelOnEveryCommit;
	refs = new N();
	tags = new N();
	tagStyles = {};
	tagRenders = {};
	commits = [];
	branches = /* @__PURE__ */ new Map();
	currentBranch;
	showBranchLabels;
	listeners = [];
	nextTimeoutId = null;
	constructor(e = {}) {
		this.template = g(e.template), this.currentBranch = this.createBranch("master"), this.orientation = e.orientation, this.reverseArrow = t(e.reverseArrow, !1), this.initCommitOffsetX = n(e.initCommitOffsetX, 0), this.initCommitOffsetY = n(e.initCommitOffsetY, 0), this.mode = e.mode, this.author = e.author || "Sergio Flores <saxo-guy@epic.com>", this.commitMessage = e.commitMessage || "He doesn't like George Michael! Boooo!", this.generateCommitHash = typeof e.generateCommitHash == "function" ? e.generateCommitHash : () => void 0, this.branchesOrderFunction = typeof e.compareBranchesOrder == "function" ? e.compareBranchesOrder : void 0, this.branchLabelOnEveryCommit = t(e.branchLabelOnEveryCommit, !1), this.showBranchLabels = e.showBranchLabels ?? !0;
	}
	getUserApi() {
		return new P(this, () => this.next());
	}
	subscribe(e) {
		this.listeners.push(e);
		let t = !0;
		return () => {
			if (!t) return;
			t = !1;
			let n = this.listeners.indexOf(e);
			this.listeners.splice(n, 1);
		};
	}
	getRenderedData() {
		let e = this.computeRenderedCommits(), t = this.computeRenderedBranchesPaths(e), n = this.computeCommitMessagesX(t);
		return this.computeBranchesColor(e, t), {
			commits: e,
			branchesPaths: t,
			commitMessagesX: n
		};
	}
	createBranch(e) {
		let t = "HEAD", n = {
			gitgraph: this,
			name: "",
			parentCommitHash: this.refs.getCommit(t),
			style: this.template.branch,
			onGraphUpdate: () => this.next()
		};
		if (typeof e == "string") n.name = e, n.parentCommitHash = this.refs.getCommit(t);
		else {
			let r = e.from ? e.from.name : t, i = this.refs.getCommit(r) || (this.refs.hasCommit(e.from) ? e.from : void 0);
			e.style = e.style || {}, n = {
				...n,
				...e,
				parentCommitHash: i,
				style: {
					...n.style,
					...e.style,
					label: {
						...n.style.label,
						...e.style.label
					}
				}
			};
		}
		let r = new C(n);
		return this.branches.set(r.name, r), r;
	}
	computeRenderedCommits() {
		let e = this.getBranches(), t = (() => {
			let t = new Set(this.commits.reduce((t, { hash: n }) => e.has(n) ? t : [...t, n], [])), n = this.commits.reduce((e, t) => t.parents.length > 1 ? [...e, ...t.parents.slice(1).map((e) => this.commits.find(({ hash: t }) => e === t))] : e, []), r = /* @__PURE__ */ new Set();
			return n.forEach((e) => {
				let n = e;
				for (; n && t.has(n.hash);) r.add(n.hash), n = n.parents.length > 0 ? this.commits.find(({ hash: e }) => n.parents[0] === e) : void 0;
			}), r;
		})(), n = this.commits.filter(({ hash: n }) => e.has(n) || t.has(n)), r = n.map((t) => this.withBranches(e, t)), i = M(this.mode, n), a = new D(r, this.template.colors, this.branchesOrderFunction);
		return r.map((e) => e.setRefs(this.refs)).map((e) => this.withPosition(i, a, e)).map((e) => e.withDefaultColor(this.getBranchDefaultColor(a, e.branchToDisplay))).map((e) => e.setTags(this.tags, (e) => Object.assign({}, this.tagStyles[e], this.template.tag), (e) => this.tagRenders[e]));
	}
	computeRenderedBranchesPaths(e) {
		return new T(e, this.branches, this.template.commit.spacing, this.isVertical, this.isReverse, () => w(this, this.template.branch, () => this.next())).execute();
	}
	computeBranchesColor(e, t) {
		let n = new D(e, this.template.colors, this.branchesOrderFunction);
		Array.from(t).forEach(([e]) => {
			e.computedColor = e.style.color || this.getBranchDefaultColor(n, e.name);
		});
	}
	computeCommitMessagesX(e) {
		return Array.from(e).length * this.template.branch.spacing;
	}
	withBranches(e, t) {
		let n = Array.from((e.get(t.hash) || /* @__PURE__ */ new Set()).values());
		return n.length === 0 && (n = [""]), t.setBranches(n);
	}
	getBranches() {
		let e = /* @__PURE__ */ new Map(), t = [];
		return this.refs.getAllNames().filter((e) => e !== "HEAD").forEach((n) => {
			let r = this.refs.getCommit(n);
			for (r && t.push(r); t.length > 0;) {
				let r = t.pop(), i = this.commits.find(({ hash: e }) => e === r), a = e.get(r) || /* @__PURE__ */ new Set();
				a.add(n), e.set(r, a), i && i.parents && i.parents.length > 0 && t.push(i.parents[0]);
			}
		}), e;
	}
	withPosition(t, n, r) {
		let i = t.getRowOf(r.hash), a = t.getMaxRow(), o = n.get(r.branchToDisplay);
		switch (this.orientation) {
			default: return r.setPosition({
				x: this.initCommitOffsetX + this.template.branch.spacing * o,
				y: this.initCommitOffsetY + this.template.commit.spacing * (a - i)
			});
			case e.VerticalReverse: return r.setPosition({
				x: this.initCommitOffsetX + this.template.branch.spacing * o,
				y: this.initCommitOffsetY + this.template.commit.spacing * i
			});
			case e.Horizontal: return r.setPosition({
				x: this.initCommitOffsetX + this.template.commit.spacing * i,
				y: this.initCommitOffsetY + this.template.branch.spacing * o
			});
			case e.HorizontalReverse: return r.setPosition({
				x: this.initCommitOffsetX + this.template.commit.spacing * (a - i),
				y: this.initCommitOffsetY + this.template.branch.spacing * o
			});
		}
	}
	getBranchDefaultColor(e, t) {
		return e.getColorOf(t);
	}
	next() {
		this.nextTimeoutId && window.clearTimeout(this.nextTimeoutId), this.nextTimeoutId = window.setTimeout(() => {
			this.listeners.forEach((e) => e(this.getRenderedData()));
		}, 0);
	}
}, I = class {
	branches = /* @__PURE__ */ new Set();
	colors;
	constructor(e, t, n) {
		this.colors = t, e.forEach((e) => this.branches.add(e.branchToDisplay)), n && (this.branches = new Set(Array.from(this.branches).sort(n)));
	}
	get(e) {
		return Array.from(this.branches).findIndex((t) => t === e);
	}
	getColorOf(e) {
		return this.colors[this.get(e) % this.colors.length];
	}
}, L = "http://www.w3.org/2000/svg";
function R(e) {
	let t = document.createElementNS(L, "svg");
	return e && (e.children && e.children.forEach((e) => t.appendChild(e)), e.viewBox && t.setAttribute("viewBox", e.viewBox), e.height && t.setAttribute("height", e.height.toString()), e.width && t.setAttribute("width", e.width.toString())), t;
}
function z(e) {
	let t = document.createElementNS(L, "g");
	return e.children.forEach((e) => e && t.appendChild(e)), e.translate && t.setAttribute("transform", `translate(${e.translate.x}, ${e.translate.y})`), e.fill && t.setAttribute("fill", e.fill), e.stroke && t.setAttribute("stroke", e.stroke), e.strokeWidth && t.setAttribute("stroke-width", e.strokeWidth.toString()), e.onClick && t.addEventListener("click", e.onClick), e.onMouseOver && t.addEventListener("mouseover", e.onMouseOver), e.onMouseOut && t.addEventListener("mouseout", e.onMouseOut), t;
}
function B(e) {
	let t = document.createElementNS(L, "text");
	return t.setAttribute("alignment-baseline", "central"), t.setAttribute("dominant-baseline", "central"), t.textContent = e.content, e.fill && t.setAttribute("fill", e.fill), e.font && t.setAttribute("style", `font: ${e.font}`), e.anchor && t.setAttribute("text-anchor", e.anchor), e.translate && (t.setAttribute("x", e.translate.x.toString()), t.setAttribute("y", e.translate.y.toString())), e.onClick && t.addEventListener("click", e.onClick), t;
}
function V(e) {
	let t = document.createElementNS(L, "circle");
	return t.setAttribute("cx", e.radius.toString()), t.setAttribute("cy", e.radius.toString()), t.setAttribute("r", e.radius.toString()), e.id && t.setAttribute("id", e.id), e.fill && t.setAttribute("fill", e.fill), t;
}
function H(e) {
	let t = document.createElementNS(L, "rect");
	return t.setAttribute("width", e.width.toString()), t.setAttribute("height", e.height.toString()), e.borderRadius && t.setAttribute("rx", e.borderRadius.toString()), e.fill && t.setAttribute("fill", e.fill || "none"), e.stroke && t.setAttribute("stroke", e.stroke), t;
}
function U(e) {
	let t = document.createElementNS(L, "path");
	return t.setAttribute("d", e.d), e.fill && t.setAttribute("fill", e.fill), e.stroke && t.setAttribute("stroke", e.stroke), e.strokeWidth && t.setAttribute("stroke-width", e.strokeWidth.toString()), e.translate && t.setAttribute("transform", `translate(${e.translate.x}, ${e.translate.y})`), t;
}
function W(e) {
	let t = document.createElementNS(L, "use");
	return t.setAttribute("href", `#${e}`), t.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", `#${e}`), t;
}
function G() {
	return document.createElementNS(L, "clipPath");
}
function K(e) {
	let t = document.createElementNS(L, "defs");
	return e.forEach((e) => t.appendChild(e)), t;
}
function q(e) {
	let t = document.createElementNS(L, "foreignObject");
	t.setAttribute("width", e.width.toString()), e.translate && (t.setAttribute("x", e.translate.x.toString()), t.setAttribute("y", e.translate.y.toString()));
	let n = document.createElement("p");
	return n.textContent = e.content, t.appendChild(n), t;
}
function J(e, t) {
	let n = H({
		width: 0,
		height: 0,
		borderRadius: e.style.label.borderRadius,
		stroke: e.style.label.strokeColor || t.style.color,
		fill: e.style.label.bgColor
	}), r = B({
		content: e.name,
		translate: {
			x: 10,
			y: 0
		},
		font: e.style.label.font,
		fill: e.style.label.color || t.style.color
	}), i = z({ children: [n] });
	return new MutationObserver(() => {
		let { height: e, width: t } = r.getBBox(), i = t + 20, a = e + 10;
		n.setAttribute("width", i.toString()), n.setAttribute("height", a.toString()), r.setAttribute("y", (a / 2).toString());
	}).observe(i, {
		attributes: !1,
		subtree: !1,
		childList: !0
	}), i.appendChild(r), i;
}
function Y(e) {
	let t = U({
		d: "",
		fill: e.style.bgColor,
		stroke: e.style.strokeColor
	}), n = B({
		content: e.name,
		fill: e.style.color,
		font: e.style.font,
		translate: {
			x: 0,
			y: 0
		}
	}), r = z({ children: [t] }), i = e.style.pointerWidth;
	return new MutationObserver(() => {
		let { height: r, width: a } = n.getBBox();
		if (r === 0 || a === 0) return;
		let o = e.style.borderRadius, s = i + a + 20, c = r + 10, l = [
			"M 0,0",
			`L ${i},${c / 2}`,
			`V ${c / 2}`,
			`Q ${i},${c / 2} ${i + o},${c / 2}`,
			`H ${s - o}`,
			`Q ${s},${c / 2} ${s},${c / 2 - o}`,
			`V -${c / 2 - o}`,
			`Q ${s},-${c / 2} ${s - o},-${c / 2}`,
			`H ${i + o}`,
			`Q ${i},-${c / 2} ${i},-${c / 2}`,
			`V -${c / 2}`,
			"z"
		].join(" ");
		t.setAttribute("d", l.toString()), n.setAttribute("x", (i + 10).toString());
	}).observe(r, {
		attributes: !1,
		subtree: !1,
		childList: !0
	}), r.appendChild(n), r;
}
// libs/gitgraph/src/js/tooltip.ts
var X = 10;
function Z(e) {
	let t = U({
		d: "",
		fill: "#EEE"
	}), n = B({
		translate: {
			x: 20,
			y: 0
		},
		content: `${e.hashAbbrev} - ${e.subject}`,
		fill: "#333"
	}), r = e.style.dot.size * 2, i = z({
		translate: {
			x: r,
			y: r / 2
		},
		children: [t]
	});
	return new MutationObserver(() => {
		let { width: e } = n.getBBox(), r = X + e + 20, i = [
			"M 0,0",
			`L ${X},${X}`,
			"V 20",
			`Q ${X},25 15,25`,
			`H ${r - 5}`,
			`Q ${r},25 ${r},20`,
			"V -20",
			`Q ${r},-25 ${r - 5},-25`,
			"H 15",
			`Q ${X},-25 ${X},-20`,
			`V -${X}`,
			"z"
		].join(" ");
		t.setAttribute("d", i.toString());
	}).observe(i, {
		attributes: !1,
		subtree: !1,
		childList: !0
	}), i.appendChild(n), i;
}
// libs/gitgraph/src/js/gitgraph.ts
function Q(t, n) {
	let r = {}, i = {}, a = !1, o, c, u = 0, d = null, f = R();
	h(!!(n && n.responsive)), t.appendChild(f), n && n.responsive && t.setAttribute("style", "display:inline-block; position: relative; width:100%; padding-bottom:100%; vertical-align:middle; overflow:hidden;");
	let p = new F(n);
	return p.subscribe((e) => {
		a = !0, m(e);
	}), p.getUserApi();
	function m(e) {
		r = {};
		let { commits: t, branchesPaths: n } = e;
		u = e.commitMessagesX, o = e, c = v(t), f.innerHTML = "", f.appendChild(z({
			translate: {
				x: 32,
				y: 10
			},
			children: [_(n), c]
		}));
	}
	function h(t) {
		new MutationObserver(() => {
			a ? (a = !1, n(), m(o)) : (s(), l(t));
		}).observe(f, {
			attributes: !1,
			subtree: !0,
			childList: !0
		});
		function n() {
			let t = Array.from(c.children), n = 0;
			i = (p.orientation === e.VerticalReverse ? t : t.reverse()).reduce((e, t) => {
				let r = parseInt(t.getAttribute("transform").split(",")[1].slice(0, -1), 10), i = t.getElementsByTagName("foreignObject")[0], a = i && i.firstElementChild;
				return e[r] = r + n, n += $(a), e;
			}, {});
		}
		function s() {
			p.isHorizontal || Object.keys(r).forEach((e) => {
				let { branchLabel: t, tags: n, message: i } = r[e];
				t && g(t, -10 - (t.getBBox().width + 20));
				let a = u;
				n.forEach((e) => {
					g(e, a);
					let t = parseFloat(e.getAttribute("data-offset") || "0"), n = e.getBBox().width + 20 + t;
					a += n + 10;
				}), i && g(i, a);
			});
		}
		function l(e) {
			let t = f.getBBox(), n = 0;
			Object.keys(r).forEach((e) => {
				let { branchLabel: t } = r[e];
				if (t) {
					let e = t.getBBox().width + 20;
					n = Math.max(n, e);
				}
			});
			let i = n + 20, a = p.isHorizontal ? 50 : 10, o = p.isHorizontal ? 50 : 35, s = p.isVertical ? -i : 0, c = 32 + t.width + i + a;
			e ? (f.setAttribute("preserveAspectRatio", "xMinYMin meet"), f.setAttribute("viewBox", `${s} 0 ${c} ${t.height + o}`)) : (f.setAttribute("width", c.toString()), f.setAttribute("height", (t.height + o).toString()), f.setAttribute("viewBox", `${s} 0 ${c} ${t.height + o}`));
		}
	}
	function g(e, t) {
		let n = e.getAttribute("transform") || "translate(0, 0)";
		e.setAttribute("transform", n.replace(/translate\(([\d\.\-]+),/, `translate(${t},`));
	}
	function _(e) {
		let t = p.template.commit.dot.size, n = p.template.branch.mergeStyle === l.Bezier;
		return z({ children: Array.from(e).flatMap(([e, r]) => r.flatMap((r) => {
			let i = (r, i) => {
				let a = U({
					d: E([r.map(T)], n, p.isVertical),
					fill: "none",
					stroke: e.computedColor || "",
					strokeWidth: e.style.lineWidth,
					translate: {
						x: t,
						y: t
					}
				});
				return i && a.setAttribute("stroke-dasharray", "5 4"), a;
			}, a = r[r.length - 1];
			if (!a || !a.dashed) return [i(r, !1)];
			let o = a.dashedFrom ? r.findIndex((e) => e.x === a.dashedFrom?.x && e.y === a.dashedFrom?.y) : -1, s = o === -1 ? r.length - 2 : o, c = r.slice(0, s + 1), l = r.slice(s);
			return [...c.length > 1 ? [i(c, !1)] : [], i(l, !0)];
		})) });
	}
	function v(e) {
		return z({ children: e.map(t) });
		function t(e) {
			let { x: t, y: r } = T(e);
			return z({
				translate: {
					x: t,
					y: r
				},
				children: [
					C(e),
					...n(e),
					z({
						translate: {
							x: -t,
							y: 0
						},
						children: [
							y(e),
							...x(e),
							...S(e)
						]
					})
				]
			});
		}
		function n(t) {
			if (!p.template.arrow.size) return [null];
			let n = t.style.dot.size;
			return t.parents.map((r) => {
				let i = e.find(({ hash: e }) => e === r);
				return i ? z({
					translate: p.reverseArrow ? {
						x: n + (i.x - t.x),
						y: n + (i.y - t.y)
					} : {
						x: n,
						y: n
					},
					children: [U({
						d: s(p, i, t),
						fill: p.template.arrow.color || ""
					})]
				}) : null;
			});
		}
	}
	function y(e) {
		if (!e.style.message.display) return null;
		let t;
		if (e.renderMessage) return t = z({ children: [] }), b(t), t.appendChild(e.renderMessage(e)), O(e, t), t;
		let n = B({
			content: e.message,
			fill: e.style.message.color || "",
			font: e.style.message.font,
			onClick: e.onMessageClick
		});
		if (t = z({
			translate: {
				x: 0,
				y: e.style.dot.size
			},
			children: [n]
		}), e.body) {
			let n = q({
				width: 600,
				translate: {
					x: 10,
					y: 0
				},
				content: e.body
			});
			b(t), t.appendChild(n);
		}
		return O(e, t), t;
	}
	function b(e) {
		new MutationObserver((e) => {
			e.forEach(({ target: e }) => t(e));
		}).observe(e, {
			attributes: !1,
			subtree: !1,
			childList: !0
		});
		function t(e) {
			if (e.nodeName === "foreignObject") {
				let t = e.firstChild && e.firstChild.parentElement;
				if (!t) return;
				t.setAttribute("height", $(t.firstElementChild).toString());
			}
			e.childNodes.forEach(t);
		}
	}
	function x(e) {
		return p.showBranchLabels ? Array.from(p.branches.values()).map((t) => {
			if (!t.style.label.display) return null;
			if (!p.branchLabelOnEveryCommit) {
				let n = p.refs.getCommit(t.name);
				if (e.hash !== n) return null;
			}
			if (e.branchToDisplay !== t.name) return null;
			let n = t.renderLabel ? t.renderLabel(t) : J(t, e), r;
			if (p.isVertical) r = z({ children: [n] });
			else {
				let t = e.style.dot.size * 2;
				r = z({
					translate: {
						x: e.x,
						y: t + 10
					},
					children: [n]
				});
			}
			return D(e, r), r;
		}) : [];
	}
	function S(e) {
		return !e.tags || p.isHorizontal ? [] : e.tags.map((t) => {
			let n = t.render ? t.render(t.name, t.style) : Y(t), r = z({
				translate: {
					x: 0,
					y: e.style.dot.size
				},
				children: [n]
			});
			return r.setAttribute("data-offset", t.style.pointerWidth.toString()), k(e, r), r;
		});
	}
	function C(e) {
		if (e.renderDot) return e.renderDot(e);
		let t = e.hash, n = V({
			id: t,
			radius: e.style.dot.size,
			fill: e.style.dot.color || ""
		}), r = `clip-${e.hash}`, i = G();
		i.setAttribute("id", r), i.appendChild(W(t));
		let a = W(t);
		a.setAttribute("clip-path", `url(#${r})`), a.setAttribute("stroke", e.style.dot.strokeColor || "");
		let o = e.style.dot.strokeWidth ? e.style.dot.strokeWidth * 2 : 0;
		a.setAttribute("stroke-width", o.toString());
		let s = e.dotText ? B({
			content: e.dotText,
			font: e.style.dot.font,
			anchor: "middle",
			translate: {
				x: e.style.dot.size,
				y: e.style.dot.size
			}
		}) : null;
		return z({
			onClick: e.onClick,
			onMouseOver: () => {
				w(e), e.onMouseOver();
			},
			onMouseOut: () => {
				d && d.remove(), e.onMouseOut();
			},
			children: [
				K([n, i]),
				a,
				s
			]
		});
	}
	function w(e) {
		if (!f.firstChild || p.isVertical && p.mode !== j.Compact || p.isVertical && !e.style.hasTooltipInCompactMode) return;
		let t = e.renderTooltip ? e.renderTooltip(e) : Z(e);
		d = z({
			translate: T(e),
			children: [t]
		}), f.firstChild.appendChild(d);
	}
	function T({ x: e, y: t }) {
		return {
			x: e,
			y: i[t] || t
		};
	}
	function D(e, t) {
		r[e.hashAbbrev] || A(e), r[e.hashAbbrev].branchLabel = t;
	}
	function O(e, t) {
		r[e.hashAbbrev] || A(e), r[e.hashAbbrev].message = t;
	}
	function k(e, t) {
		r[e.hashAbbrev] || A(e), r[e.hashAbbrev].tags.push(t);
	}
	function A(e) {
		r[e.hashAbbrev] = {
			branchLabel: null,
			tags: [],
			message: null
		};
	}
}
function $(e) {
	let t = 0;
	if (e) {
		let n = e.getBoundingClientRect().height, r = window.getComputedStyle(e).marginTop || "0px";
		t = n + parseInt(r.replace("px", ""), 10);
	}
	return t;
}
export { C as Branch, b as BranchUserApi, I as BranchesOrder, T as BranchesPathsCalculator, D as ColumnManager, y as Commit, u as DEFAULT_FONT, S as DELETED_BRANCH_NAME, F as GitgraphCore, P as GitgraphUserApi, l as MergeStyle, j as Mode, e as Orientation, N as Refs, _ as Tag, d as Template, m as TemplateName, s as arrowSvgPath, f as blackArrowTemplate, t as booleanOptionOr, V as createCircle, G as createClipPath, K as createDefs, w as createDeletedBranch, q as createForeignObject, z as createG, Q as createGitgraph, U as createPath, H as createRect, R as createSvg, B as createText, W as createUse, i as debug, g as getTemplate, a as isUndefined, p as metroTemplate, n as numberOptionOr, r as pick, h as templateExtend, E as toSvgPath, o as withoutUndefinedKeys };
